var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_959_2856",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.699219,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_959_2856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1986 6.66659C18.643 6.66659 19.0319 6.83325 19.3652 7.16658C19.6986 7.49992 19.8652 7.88881 19.8652 8.33325V9.99992C19.8652 10.0971 19.8513 10.2013 19.8236 10.3124C19.7958 10.4235 19.768 10.5277 19.7402 10.6249L17.2402 16.4999C17.1152 16.7777 16.9069 17.0138 16.6152 17.2083C16.3236 17.4027 16.018 17.4999 15.6986 17.4999H6.5319V6.66659L11.5319 1.70825C11.7402 1.49992 11.9868 1.37839 12.2715 1.34367C12.5562 1.30895 12.8305 1.36103 13.0944 1.49992C13.3583 1.63881 13.5527 1.83325 13.6777 2.08325C13.8027 2.33325 13.8305 2.5902 13.7611 2.85409L12.8236 6.66659H18.1986ZM8.19857 7.37492V15.8333H15.6986L18.1986 9.99992V8.33325H10.6986L11.8236 3.74992L8.19857 7.37492ZM4.0319 17.4999C3.57357 17.4999 3.18121 17.3367 2.85482 17.0103C2.52843 16.6839 2.36523 16.2916 2.36523 15.8333V8.33325C2.36523 7.87492 2.52843 7.48256 2.85482 7.15617C3.18121 6.82978 3.57357 6.66659 4.0319 6.66659H6.5319V8.33325H4.0319V15.8333H6.5319V17.4999H4.0319Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.7e0f310c58c43b15952856b8d670b371.svg";
export { ForwardRef as ReactComponent };